export const T = {
  bg: "#EEF0FB",
  surface: "#FFFFFF",
  surfaceAlt: "#E4E6F7",
  line: "#D8DBF0",
  text: "#1E1E33",
  textDim: "#63628A",
  amber: "#FF6B35",
  teal: "#06A66B",
  rose: "#F0355E",
  viki: "#7C4DFF",
  ink: "#FFFFFF",
  font: "'IBM Plex Sans', -apple-system, sans-serif",
  fontHead: "'Space Grotesk', -apple-system, sans-serif",
};

export const PLAN_LIMITS = { free: 1, pro: 5, agency: Infinity };
export const PLAN_LABELS = { free: "Free", pro: "Pro", agency: "Agency" };
export const weekDays = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export function todayLabel() {
  const jsDay = new Date().getDay();
  return weekDays[(jsDay + 6) % 7];
}

export const inputStyle = {
  background: T.surface, border: `1px solid ${T.line}`, borderRadius: 6,
  padding: "8px 10px", color: T.text, fontFamily: T.font, fontSize: 13,
  outline: "none", width: "100%",
};
export const labelStyle = { color: T.textDim, fontSize: 12, marginBottom: 4, display: "block" };
export const primaryBtn = {
  background: T.amber, color: T.ink, border: "none", borderRadius: 999,
  padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer",
};

export function downloadBlob(filename, content, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function getEngagementVerdict(benchmarks, followers, engagementPct) {
  const tier = benchmarks.find((b) => b.maxFollowers === null || followers <= b.maxFollowers) || benchmarks[benchmarks.length - 1];
  if (engagementPct >= tier.good) return { label: "Sopra la media", color: T.teal, tierLabel: tier.tierLabel };
  if (engagementPct >= tier.low) return { label: "Nella media", color: T.amber, tierLabel: tier.tierLabel };
  return { label: "Sotto la media", color: T.rose, tierLabel: tier.tierLabel };
}

export function fmtDateIT(iso) {
  if (!iso || typeof iso !== "string" || iso.split("-").length !== 3) return iso || "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}
